import * as React from "react";
const facebook = require("../images/facebook.svg");
const twitter = require("../images/twitter.svg");
const linkedin = require("../images/linkedin.svg");
const instagram = require("../images/instagram.svg");

const facebookLink = "https://www.facebook.com/fikafyapp/";
const twitterLink = "https://twitter.com/fikafyapp";
const linkedinLink = "https://www.linkedin.com/company/fikafy/";
const instagramLink = "https://www.instagram.com/fikafyapp/";

class SocialMenu extends React.Component {
  render(): JSX.Element {
    return (
      <div className="social-menu">
        <div className="social-item">
          <a href={facebookLink}>
            <img src={facebook} alt="facebook" height="100px" width="100px" />
          </a>
        </div>
        <div className="social-item">
          <a href={twitterLink}>
            <img src={twitter} alt="twitter" height="100px" width="100px" />
          </a>
        </div>
        <div className="social-item">
          <a href={linkedinLink}>
            <img src={linkedin} alt="linkedin" height="100px" width="100px" />
          </a>
        </div>
        <div className="social-item">
          <a href={instagramLink}>
            <img src={instagram} alt="instagram" height="100px" width="100px" />
          </a>
        </div>
      </div>
    );
  }
}

export default SocialMenu;



// WEBPACK FOOTER //
// ./src/components/socialmenu.component.tsx